import { BuildType } from '../../src/enums/build/build-type';

export const isAbbySupportedByBuildType = (buildType: BuildType) =>
  buildType === BuildType.DAVID_LLOYD_UK ||
  buildType === BuildType.DAVID_LLOYD_SPAIN ||
  buildType === BuildType.DAVID_LLOYD_NETHERLANDS;
